import { Box, Button, Card, CardBody, CardHeader, CheckBox, Form, FormField, Heading, Image, Layer, Notification, Paragraph, RadioButtonGroup, Text, TextInput } from "grommet"
import { formattedPrice, formattedPriceNumber } from "../../../utils/priceUtils"
import { useParams } from "react-router-dom";
import { PaymentOptionsSelector } from "./PaymentOptionsSelector";
import { useGetPaymentOptionsByUsernameQuery } from "../../../api/paymentOptionsApi";
import { useEffect, useState } from "react";
import { useCreateRouletteDonateRecordMutation } from "../../../api/donateRecordsApi";
import { useGetCurrentUserQuery } from "../../../api/userApi";
import { useSelector } from "react-redux";
import { authenticationSelector } from "../../../slices/authSlice";
import { Close } from "grommet-icons";
import { useTranslation } from "react-i18next";

const senderValidationRules = [
    {
        regexp: /^.{3,128}$/,
        message: 'Sender should be min 3 max 128 characters',
        status: 'error',
    }
]

export const RouletteDonateVariantDialog = ({ data, onClose, onSubmit }) => {

    const params = useParams();

    const { t } = useTranslation('donations', { useSuspense: false });

    const isAuthenticated = useSelector(authenticationSelector);
    const { data: currentUser, isLoading: isCurrentUserLoading, isError: isCurrentUserError, isSuccess: isCurrentUserSuccess } = useGetCurrentUserQuery(undefined, {skip: !isAuthenticated});

    const { data: paymentOptions, isSuccess: isPaymentOptionsLoaded } = useGetPaymentOptionsByUsernameQuery({ username: params.username });

    const [createRouletteDonateRecord] = useCreateRouletteDonateRecordMutation();

    const [formValue, setFormValue] = useState({
        sender: '',
        anonymous: false,
        amount: 0,
        paymentOption: undefined
    });

    const handleSubmit = (value) => {
        const option = value.paymentOption;
        const sender = value.anonymous ? 'Anonymous' : value.sender;

        createRouletteDonateRecord({
            currencyAmount: value.amount * 100,
            anonymous: value.anonymous,
            sender: sender,
            receiver: params.username,
            message: value.lotName
        }).then(response => {
            const data = response.data;

            const paymentOptionValue = paymentOptions.filter(paymentOption => paymentOption.type === option)[0];

            let link;
            if (option === 'MONOBANK') {
                link = paymentOptionValue.paymentLinkTemplate.replace('[sendId]', paymentOptionValue.sendId).replace('[message]', data.id).replace('[amount]', formattedPriceNumber(data.donateAmount));
            } else {
                link = paymentOptionValue.paymentLinkTemplate.replace('[sender]', sender).replace('[message]', data.id).replace('[amount]', formattedPriceNumber(data.donateAmount));
            }

            onSubmit({ ...value, ...{ paymentOption: link } })
        })
    }

    useEffect(() => {
        if (currentUser && !formValue.anonymous) {
            setFormValue(prevValue => ({ ...prevValue, ...{ sender: currentUser.username } }));
        } else if (formValue.anonymous) {
            setFormValue(prevValue => ({ ...prevValue, ...{ sender: 'Anonymous' } }));
        } else {
            setFormValue(prevValue => ({ ...prevValue, ...{ sender: '' } }));
        }
    }, [currentUser, formValue.anonymous])

    useEffect(() => {
        if (!data || !data.data) return;

        setFormValue(prevValue => ({ ...prevValue, ...{ amount: formattedPriceNumber(data.data.cost) } }));
    }, [data])

    useEffect(() => {
        if (isPaymentOptionsLoaded && paymentOptions.length > 0) {
            setFormValue(prevValue => ({ ...prevValue, ...{ paymentOption: paymentOptions[0].type } }));
        }
    }, [paymentOptions, isPaymentOptionsLoaded])

    if (data.show && isPaymentOptionsLoaded) {
        return (
            <Layer onClickOutside={onClose}>
                <Card width={'medium'}>
                    <CardHeader justify="between" pad={{ top: 'medium', left: 'medium', right: 'medium' }}>
                        <Heading level={3} margin={'none'} weight={'bold'}>{t('rouletteRequestHeader')}</Heading>
                        <Button icon={<Close />} onClick={onClose} />
                    </CardHeader>
                    <CardBody direction="row" gap="medium">
                        <Box flex>
                            <Form value={formValue} onChange={(value) => setFormValue(value)} onSubmit={({ value }) => handleSubmit(value)}>
                                <Box gap="small">
                                    <Box gap="none" fill>
                                        <Box>
                                            <FormField name="sender" label={t('usernameLabel')} required={{ indicator: !formValue.anonymous }} validate={senderValidationRules}>
                                                <TextInput id="sender" name="sender" placeholder={t('usernamePlaceholder')} disabled={formValue.anonymous} />
                                            </FormField>
                                        </Box>
                                        <Box >
                                            <FormField name="anonymous" noBorder noHover>
                                                <CheckBox id="anonymous" toggle name="anonymous" label={t('anonymousLabel')} />
                                            </FormField>
                                        </Box>
                                    </Box>
                                    <FormField name="amount" label={t('amountLabel')}>
                                        <TextInput id="amount" name="amount" placeholder="UAH" type="number" disabled />
                                    </FormField>
                                    <PaymentOptionsSelector paymentOptions={paymentOptions} />
                                    <Notification message={t('paymentDisclaimer')} status="warning" />
                                    <Box alignSelf="end">
                                        <Button type="submit" label={t('sendBtn')} primary />
                                    </Box>
                                </Box>
                            </Form>
                        </Box>
                    </CardBody>
                </Card>
            </Layer>
        )
    }
}